import { createSelector } from '@reduxjs/toolkit';
import { resourceSelectors } from '../../utils/resourceSelectors';

export const [formsAllIds, formsById, allFormsSelector] =
  resourceSelectors('forms');

export const createFormByIdSelector = (id) =>
  createSelector(formsById, (byId) => byId[id]);
